import { Component, computed, HostAttributeToken, inject, input, model, output } from '@angular/core';

import { OrderData, SubStateItem } from '@lfw/roesberg.liveforms.core';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'lfw-sub-state-select',
  imports: [MatSelect, MatOption, MatFormFieldModule, FormsModule],
  templateUrl: './sub-state-select.component.html',
  styleUrl: './sub-state-select.component.css'
})
export class SubStateSelectComponent {
  availableStates = input.required<SubStateItem[]>();
  order = model.required<OrderData>();
  changed = output<SubStateItem | undefined>();
  disabled: string | null = inject(new HostAttributeToken('disabled'), { optional: true });

  options = computed(() => {
    const currentSubstate = this.order().orderSubState;
    if (currentSubstate && !this.availableStates().find((state) => state.text === currentSubstate.text)) {
      const deprecatedOption = currentSubstate;
      deprecatedOption.text = `${currentSubstate.text}`;
      deprecatedOption.displayText = `⛔ ${currentSubstate.text}`;
      return [undefined, ...this.availableStates(), deprecatedOption];
    }
    return [undefined, ...this.availableStates()];
  });

  getSelectedItemStyle(): string {
    if (this.order == undefined || !this.order().orderSubState) {
      return '';
    }
    return this.order().orderSubState?.getStyle() || '';
  }

  getItemStyle(item: SubStateItem | undefined): string | undefined {
    return item?.getStyle();
  }

  setSelectedValue(value: SubStateItem | undefined) {
    if (this.order == undefined) {
      return;
    }
    this.order.update((order) => {
      order.orderSubState = value;
      return order;
    });
    this.changed.emit(value);
  }

  compareFn(prev?: SubStateItem, curr?: SubStateItem) {
    return prev?.text === curr?.text;
  }
}
